import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendar3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendar3"><Path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H15V4H9V2H7V4ZM7 10V8H17V10H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendar3;
